const documentation = `# End node

If you have a Start node, you must also have an End node. The End node is just the final node of an application, nothing more, nothing less. The End node includes a delay of 2 seconds, in order for the last messages to properly arrive to LocSys.
`;

export default documentation;
